<template>
  <div class="secret">
    <div class="secret__top">
      <picture>
        <source
          :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/secret/banner_mob.jpg`"
          media="(max-width: 1220px)"
        />
        <source
          :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/secret/banner.jpg`"
          media="(min-width: 1221px)"
        />
        <img
          class="secret__top-img"
          :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/secret/banner.jpg`"
        />
      </picture>
      <div class="content">
        <div class="secret__top-text">
          <div class="secret__top-caption">Не по секрету</div>
          <div class="secret__top-subcaption">
            Разговоры о сахарном диабете вместе с член-корреспондентом РАН,
            д.м.н., профессором Петуниной Н.А.
          </div>
          <div class="secret__top-description">
            Проект посвящен обсуждению актуальных вопросов по тактике ведения
            пациентов с сахарным диабетом 2 типа, в том числе при наличии таких
            ассоциированных заболеваний как хроническая болезнь почек (ХБП) и
            хроническая сердечная недостаточность (ХСН). Вы можете ознакомиться
            с видео-роликами, в которых вы найдете как обзор российских и
            международных клинических рекомендаций по ведению пациентов с СД2
            типа, с учетом наличия у них тех или иных осложнений, так и
            представление данных клинических исследований, а также обсуждение
            вопросов безопасности терапии.
          </div>
          <div class="secret__top-button button">
            Смотреть видео
            <svg
              class="ml-2"
              width="28"
              height="38"
              viewBox="0 0 28 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.4404 14.8236H24.3891C23.6895 14.8197 23.0135 15.0787 22.4931 15.5502C22.0718 14.3751 21.0013 13.5306 19.7473 13.5306C19.3669 13.5332 18.9908 13.6127 18.6413 13.7642C18.2918 13.9158 17.9759 14.1363 17.7124 14.4129C17.2227 13.414 16.2406 12.7363 15.1113 12.7363H15.0568C14.4514 12.727 13.861 12.9253 13.3822 13.2986V6.17718C13.3822 4.4562 12.0527 3.05627 10.4357 3.05627C8.82036 3.05627 7.49792 4.45527 7.49692 6.17501L7.4835 20.3044L6.69007 19.3333C6.34596 18.9014 5.91729 18.5457 5.43077 18.2881C4.94425 18.0306 4.41032 17.8768 3.86224 17.8364C3.32532 17.7993 2.78655 17.8735 2.2792 18.0545C1.77185 18.2354 1.30669 18.5193 0.912452 18.8885L0.22212 19.4649C0.114094 19.5551 0.0400004 19.6799 0.0121839 19.8185C-0.0156325 19.9571 0.0045079 20.1011 0.0692496 20.2265L6.78112 33.2293C8.00838 35.6055 10.3434 37.0879 12.8749 37.0879H20.4389V37.0812C24.2741 37.0812 27.3836 33.7272 27.3875 29.6089C27.389 27.7662 27.3821 26.3929 27.3833 25.2798C27.3871 22.3017 27.3842 21.2028 27.3767 17.9218C27.3728 16.2049 26.0529 14.8236 24.4404 14.8236ZM26.147 25.2756C26.1458 26.3889 26.144 27.7678 26.1422 29.6104C26.139 33.0478 23.5643 35.8507 20.4029 35.8507H12.8752C10.803 35.8507 8.8851 34.6232 7.87031 32.6579L1.38671 20.1015L1.70672 19.8325C1.71485 19.8258 1.7226 19.818 1.73042 19.811C2.00266 19.5527 2.32473 19.3537 2.67659 19.2263C3.02846 19.0989 3.40257 19.0459 3.77564 19.0706C4.15696 19.1 4.52817 19.2083 4.86613 19.3887C5.2041 19.569 5.50158 19.8177 5.74002 20.119L7.61827 22.4225C7.69848 22.521 7.80694 22.5921 7.92879 22.6261C8.05064 22.66 8.17994 22.6553 8.29899 22.6124C8.41804 22.5695 8.52103 22.4905 8.59387 22.3864C8.66672 22.2822 8.70585 22.1579 8.70592 22.0305L8.71704 6.17563C8.71758 5.13742 9.49666 4.29285 10.4363 4.29285C11.3759 4.29285 12.1549 5.13827 12.1549 6.17718V15.7368C12.1549 15.77 12.1534 15.8035 12.1534 15.8373C12.1534 15.8518 12.1549 15.8666 12.1549 15.8808V19.968C12.1549 20.132 12.2196 20.2893 12.3346 20.4053C12.4497 20.5213 12.6058 20.5865 12.7685 20.5865C12.9313 20.5865 13.0874 20.5213 13.2024 20.4053C13.3175 20.2893 13.3822 20.132 13.3822 19.968V15.7576C13.3822 14.7559 14.1414 13.9732 15.0568 13.9732H15.1113C16.0515 13.9732 16.8338 14.7991 16.8338 15.838V19.5779C16.8338 19.7419 16.8985 19.8992 17.0135 20.0152C17.1286 20.1311 17.2847 20.1963 17.4474 20.1963C17.6102 20.1963 17.7663 20.1311 17.8814 20.0152C17.9964 19.8992 18.0611 19.7419 18.0611 19.5779V16.6436C18.0611 15.6046 18.8059 14.7593 19.7512 14.7593C20.6912 14.7593 21.436 15.6043 21.436 16.6436V19.4119C21.436 19.5759 21.5007 19.7332 21.6158 19.8492C21.7308 19.9652 21.8869 20.0303 22.0497 20.0303C22.2124 20.0303 22.3685 19.9652 22.4836 19.8492C22.5986 19.7332 22.6633 19.5759 22.6633 19.4119V17.9129C22.6633 16.8738 23.4489 16.0605 24.3891 16.0605H24.4404C25.3782 16.0605 26.1425 16.8877 26.1449 17.9234C26.1524 21.202 26.1509 22.2997 26.147 25.2757V25.2756Z"
                fill="currentColor"
              />
              <path
                d="M5.5473 6.44416C5.71004 6.44416 5.86612 6.379 5.9812 6.26302C6.09628 6.14704 6.16093 5.98974 6.16093 5.82572C6.17075 3.46581 8.07184 1.55822 10.4131 1.55822C12.7547 1.55822 14.6555 3.46581 14.6654 5.82572C14.6654 5.98974 14.73 6.14704 14.8451 6.26302C14.9602 6.379 15.1162 6.44416 15.279 6.44416C15.4417 6.44416 15.5978 6.379 15.7129 6.26302C15.828 6.14704 15.8926 5.98974 15.8926 5.82572C15.8813 2.78359 13.4315 0.32373 10.4131 0.32373C7.39501 0.32373 4.94495 2.78359 4.93359 5.82572C4.93359 5.98974 4.99824 6.14704 5.11332 6.26302C5.2284 6.379 5.38455 6.44416 5.5473 6.44416Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="secret__slider">
      <div class="content">
        <div class="secret__slider-container">
          <div class="secret__slider-arrows">
            <div
              class="secret__slider-arrow secret__slider-arrow_left"
              @click="$refs.secretSlider.prev()"
            >
              <svg
                width="10"
                height="19"
                viewBox="0 0 10 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.76001 1.43994L1.03044 9.34979C0.970328 9.40752 0.922415 9.47725 0.889661 9.55468C0.856908 9.6321 0.840008 9.71557 0.840008 9.79994C0.840008 9.88431 0.856908 9.96778 0.889661 10.0452C0.922415 10.1226 0.970328 10.1924 1.03044 10.2501L8.76001 18.1599"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              class="secret__slider-arrow secret__slider-arrow_right"
              @click="$refs.secretSlider.next()"
            >
              <svg
                width="10"
                height="19"
                viewBox="0 0 10 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.839844 18.1602L8.56941 10.2503C8.62953 10.1926 8.67744 10.1228 8.71019 10.0454C8.74295 9.968 8.75984 9.88452 8.75984 9.80016C8.75984 9.71579 8.74295 9.63232 8.71019 9.55489C8.67744 9.47747 8.62953 9.40774 8.56941 9.35L0.839844 1.44016"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <VueSlickCarousel
            v-bind="settings"
            class="secret__slider-slider"
            ref="secretSlider"
          >
            <div class="secret__slider-slide">
              <div class="secret-slide__icon">
                <svg
                  width="243"
                  height="243"
                  viewBox="0 0 243 243"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.88675 126.5C1.10042 123.406 1.10042 119.594 2.88675 116.5L57.8632 21.2779C59.6496 18.1839 62.9508 16.2779 66.5235 16.2779L176.476 16.2779C180.049 16.2779 183.35 18.1839 185.137 21.2779L240.113 116.5C241.9 119.594 241.9 123.406 240.113 126.5L185.137 221.722C183.35 224.816 180.049 226.722 176.477 226.722L66.5235 226.722C62.9508 226.722 59.6496 224.816 57.8632 221.722L2.88675 126.5Z"
                    fill="#1070FF"
                  />
                  <path
                    d="M141.416 142.019C141.228 142.019 141.041 141.982 140.866 141.909C140.692 141.837 140.534 141.731 140.401 141.597L110.871 112.067C110.738 111.934 110.633 111.777 110.561 111.603C110.489 111.43 110.452 111.243 110.452 111.056C110.452 110.868 110.489 110.682 110.561 110.508C110.633 110.334 110.738 110.177 110.871 110.044L132.064 88.851C132.197 88.7181 132.355 88.6126 132.528 88.5406C132.702 88.4687 132.888 88.4316 133.076 88.4316C133.264 88.4316 133.45 88.4687 133.623 88.5406C133.797 88.6126 133.955 88.7181 134.087 88.851L163.617 118.381C163.75 118.514 163.856 118.671 163.928 118.845C164 119.019 164.037 119.205 164.037 119.393C164.037 119.58 164 119.767 163.928 119.94C163.856 120.114 163.75 120.271 163.617 120.404L142.424 141.597C142.158 141.866 141.795 142.017 141.416 142.019ZM113.903 111.052L141.416 138.565L160.586 119.396L133.072 91.8827L113.903 111.052Z"
                    fill="white"
                  />
                  <path
                    d="M97.1359 159.622C96.1437 159.622 95.1824 159.277 94.4157 158.647C93.6491 158.017 93.1245 157.141 92.9313 156.168C92.7382 155.194 92.8884 154.184 93.3564 153.309C93.8243 152.434 94.5812 151.748 95.4979 151.369C96.4147 150.989 97.4347 150.939 98.3843 151.227C99.3338 151.515 100.154 152.123 100.706 152.948C101.257 153.773 101.506 154.763 101.409 155.751C101.312 156.739 100.876 157.662 100.175 158.364C99.7759 158.763 99.3022 159.08 98.7807 159.296C98.2593 159.512 97.7003 159.623 97.1359 159.622ZM97.1359 153.902C96.854 153.904 96.5787 153.988 96.3446 154.145C96.1106 154.302 95.9282 154.525 95.8204 154.786C95.7127 155.047 95.6844 155.333 95.7391 155.61C95.7938 155.886 95.929 156.141 96.1278 156.341C96.2606 156.474 96.4183 156.579 96.5919 156.651C96.7655 156.723 96.9516 156.76 97.1395 156.76C97.3274 156.76 97.5135 156.723 97.6871 156.651C97.8607 156.579 98.0184 156.474 98.1512 156.341C98.3505 156.14 98.4858 155.885 98.5403 155.608C98.5947 155.331 98.5658 155.044 98.4572 154.783C98.3486 154.522 98.1651 154.299 97.93 154.142C97.6948 153.986 97.4185 153.902 97.1359 153.902Z"
                    fill="white"
                  />
                  <path
                    d="M134.481 124.551C133.183 124.549 131.915 124.162 130.836 123.44C129.758 122.718 128.918 121.693 128.421 120.493C127.925 119.294 127.795 117.975 128.047 116.702C128.3 115.429 128.924 114.259 129.84 113.34C133.887 109.286 142.882 107.62 143.268 107.541C143.491 107.502 143.719 107.516 143.935 107.582C144.152 107.647 144.349 107.764 144.512 107.921C144.674 108.078 144.797 108.271 144.871 108.485C144.944 108.698 144.966 108.926 144.934 109.15C144.884 109.515 143.619 118.138 139.128 122.628C138.52 123.241 137.796 123.726 136.998 124.056C136.2 124.387 135.344 124.555 134.481 124.551ZM141.695 110.823C138.957 111.538 134.223 112.968 131.864 115.363C131.169 116.058 130.778 117.001 130.778 117.984C130.778 118.967 131.169 119.909 131.864 120.604C132.559 121.299 133.501 121.69 134.484 121.69C135.467 121.69 136.41 121.299 137.105 120.604C139.707 118.009 141.08 113.476 141.695 110.823Z"
                    fill="white"
                  />
                  <path
                    d="M109.599 138.808C109.41 138.809 109.224 138.773 109.05 138.702C108.875 138.631 108.717 138.526 108.583 138.394L101.083 130.865C99.6678 129.391 98.8869 127.421 98.9078 125.378C98.9286 123.335 99.7495 121.381 101.194 119.936C102.639 118.492 104.593 117.671 106.636 117.65C108.679 117.629 110.649 118.41 112.122 119.825L119.623 127.325C119.756 127.458 119.861 127.616 119.933 127.789C120.005 127.963 120.042 128.149 120.042 128.337C120.042 128.525 120.005 128.711 119.933 128.885C119.861 129.058 119.756 129.216 119.623 129.349L110.607 138.365C110.476 138.502 110.32 138.612 110.147 138.688C109.974 138.764 109.788 138.805 109.599 138.808ZM106.603 120.411C105.628 120.415 104.675 120.707 103.866 121.25C103.056 121.793 102.425 122.563 102.051 123.463C101.678 124.364 101.578 125.355 101.766 126.312C101.954 127.269 102.42 128.148 103.106 128.841L109.599 135.326L116.584 128.341L110.085 121.848C109.627 121.392 109.084 121.029 108.487 120.783C107.889 120.536 107.249 120.41 106.603 120.411Z"
                    fill="white"
                  />
                  <path
                    d="M127.123 153.659C126.099 153.663 125.084 153.464 124.136 153.073C123.189 152.683 122.328 152.11 121.603 151.386L114.11 143.885C113.977 143.752 113.872 143.595 113.8 143.421C113.728 143.247 113.691 143.061 113.691 142.873C113.691 142.685 113.728 142.499 113.8 142.326C113.872 142.152 113.977 141.994 114.11 141.862L123.119 132.845C123.252 132.712 123.41 132.607 123.583 132.535C123.757 132.463 123.943 132.426 124.131 132.426C124.319 132.426 124.505 132.463 124.679 132.535C124.852 132.607 125.01 132.712 125.143 132.845L132.643 140.346C133.737 141.436 134.482 142.826 134.784 144.34C135.086 145.854 134.932 147.424 134.341 148.851C133.749 150.277 132.747 151.495 131.463 152.352C130.178 153.208 128.667 153.663 127.123 153.659ZM117.113 142.87L123.598 149.362C124.524 150.293 125.781 150.818 127.094 150.823C128.407 150.827 129.667 150.309 130.598 149.384C131.529 148.458 132.055 147.201 132.059 145.888C132.063 144.575 131.545 143.315 130.62 142.384L124.127 135.899L117.113 142.87Z"
                    fill="white"
                  />
                  <path
                    d="M169.967 106.726L145.742 82.5019C142.401 79.1818 137.882 77.3184 133.172 77.3184C128.462 77.3184 123.944 79.1818 120.603 82.5019L88.8135 114.291C85.4934 117.632 83.6299 122.151 83.6299 126.861C83.6299 131.571 85.4934 136.09 88.8135 139.431L93.8185 144.436L84.0515 154.267C83.9186 154.4 83.8131 154.558 83.7411 154.731C83.6691 154.905 83.6321 155.091 83.6321 155.279C83.6321 155.467 83.6691 155.653 83.7411 155.826C83.8131 156 83.9186 156.158 84.0515 156.291L96.2066 168.446C96.3394 168.579 96.4971 168.684 96.6707 168.756C96.8443 168.828 97.0304 168.865 97.2183 168.865C97.4063 168.865 97.5924 168.828 97.766 168.756C97.9396 168.684 98.0973 168.579 98.2301 168.446L108.033 158.65L113.038 163.655C116.379 166.975 120.898 168.839 125.608 168.839C130.318 168.839 134.837 166.975 138.177 163.655L169.967 131.866C173.287 128.525 175.15 124.006 175.15 119.296C175.15 114.586 173.287 110.067 169.967 106.726ZM97.2148 165.385L87.0831 155.254L100.468 141.89C102.444 143.248 104.281 144.798 105.952 146.516C107.671 148.188 109.221 150.025 110.578 152L97.2148 165.385ZM168 129.842L136.154 161.632C133.35 164.416 129.559 165.979 125.608 165.979C121.656 165.979 117.865 164.416 115.061 161.632L110.056 156.627L111.586 155.096C111.628 155.398 111.769 155.678 111.987 155.89C112.255 156.156 112.617 156.306 112.995 156.306C113.373 156.306 113.735 156.156 114.003 155.89C115.354 154.539 114.153 152.265 113.131 150.678C111.626 148.458 109.898 146.398 107.976 144.529C106.103 142.615 104.04 140.898 101.819 139.402C100.232 138.38 97.9584 137.171 96.607 138.53C96.3407 138.798 96.1912 139.16 96.1912 139.538C96.1912 139.916 96.3407 140.278 96.607 140.546C96.8205 140.763 97.0994 140.904 97.4007 140.946L95.8706 142.477L90.8655 137.472C88.0807 134.668 86.5178 130.877 86.5178 126.925C86.5178 122.974 88.0807 119.182 90.8655 116.379L122.626 84.5254C125.43 81.7406 129.221 80.1777 133.172 80.1777C137.124 80.1777 140.915 81.7406 143.719 84.5254L167.943 108.778C170.728 111.582 172.291 115.373 172.291 119.325C172.291 123.276 170.728 127.068 167.943 129.871L168 129.842Z"
                    fill="white"
                  />
                  <path
                    d="M68.0048 110.77L86.1633 79.3184L104.322 110.77H68.0048Z"
                    fill="white"
                    stroke="white"
                    stroke-width="2"
                  />
                  <path
                    d="M87.7722 91.6093L87.4432 101.687H85.0508L84.7119 91.6093H87.7722ZM84.6321 104.808C84.6321 104.382 84.7783 104.03 85.0707 103.751C85.3698 103.465 85.7619 103.322 86.247 103.322C86.7388 103.322 87.1309 103.465 87.4233 103.751C87.7157 104.03 87.8619 104.382 87.8619 104.808C87.8619 105.22 87.7157 105.569 87.4233 105.854C87.1309 106.14 86.7388 106.283 86.247 106.283C85.7619 106.283 85.3698 106.14 85.0707 105.854C84.7783 105.569 84.6321 105.22 84.6321 104.808Z"
                    fill="#1070FF"
                  />
                </svg>
              </div>
              <div class="secret-slide__text">
                Реальная численность пациентов с СД 2 в РФ примерно 11-12 млн
                (около 7% населения)<sup>1</sup>
              </div>
            </div>
            <div class="secret__slider-slide">
              <div class="secret-slide__icon">
                <svg
                  width="243"
                  height="243"
                  viewBox="0 0 243 243"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.88675 126.5C1.10042 123.406 1.10042 119.594 2.88675 116.5L57.8632 21.2779C59.6496 18.1839 62.9508 16.2779 66.5235 16.2779L176.476 16.2779C180.049 16.2779 183.35 18.1839 185.137 21.2779L240.113 116.5C241.9 119.594 241.9 123.406 240.113 126.5L185.137 221.722C183.35 224.816 180.049 226.722 176.477 226.722L66.5235 226.722C62.9508 226.722 59.6496 224.816 57.8632 221.722L2.88675 126.5Z"
                    fill="#1070FF"
                  />
                  <path
                    d="M154.884 68.5046C154.56 68.1815 154.122 68 153.665 68C153.208 68 152.77 68.1815 152.447 68.5046L147.277 73.6748C146.953 73.998 146.772 74.4363 146.772 74.8932C146.772 75.3502 146.953 75.7885 147.277 76.1117L152.09 80.9252L146.772 86.2436L142.82 82.2918C142.497 81.9687 142.058 81.7872 141.601 81.7872C141.144 81.7872 140.706 81.9687 140.383 82.2918L90.4042 132.271C90.0812 132.594 89.8997 133.032 89.8997 133.489C89.8997 133.946 90.0812 134.384 90.4042 134.707L93.4943 137.797L88.6808 142.611C88.3578 142.934 88.1763 143.372 88.1763 143.829C88.1763 144.286 88.3578 144.725 88.6808 145.048L91.7709 148.138L68 171.909L70.4369 174.346L94.2078 150.575L97.2979 153.665C97.621 153.988 98.0593 154.169 98.5163 154.169C98.9733 154.169 99.4116 153.988 99.7348 153.665L104.548 148.851L107.638 151.941C107.961 152.265 108.4 152.446 108.857 152.446C109.314 152.446 109.752 152.265 110.075 151.941L142.834 119.185C143.523 119.522 144.28 119.699 145.048 119.702V123.149H143.325C141.497 123.149 139.743 123.875 138.45 125.168C137.157 126.46 136.431 128.214 136.431 130.042V167.957C136.431 169.785 137.157 171.539 138.45 172.832C139.743 174.124 141.497 174.851 143.325 174.851H164.006C165.834 174.851 167.587 174.124 168.88 172.832C170.173 171.539 170.899 169.785 170.899 167.957V130.042C170.899 128.214 170.173 126.46 168.88 125.168C167.587 123.875 165.834 123.149 164.006 123.149H162.282V119.702C163.653 119.702 164.969 119.157 165.938 118.187C166.908 117.218 167.452 115.903 167.452 114.532C167.452 113.16 166.908 111.845 165.938 110.876C164.969 109.906 163.653 109.361 162.282 109.361V107.638C162.282 106.624 161.984 105.632 161.424 104.786C160.864 103.941 160.069 103.278 159.135 102.881L160.054 101.963C160.377 101.64 160.558 101.201 160.558 100.744C160.558 100.287 160.377 99.849 160.054 99.5259L156.102 95.5741L161.421 90.2557L166.234 95.0691C166.557 95.3922 166.995 95.5737 167.452 95.5737C167.909 95.5737 168.348 95.3922 168.671 95.0691L173.841 89.8989C174.164 89.5757 174.346 89.1375 174.346 88.6805C174.346 88.2235 174.164 87.7852 173.841 87.462L154.884 68.5046ZM98.5163 150.01L92.3362 143.829L95.9312 140.234L102.111 146.414L98.5163 150.01ZM108.857 148.286L94.0596 133.489L116.464 111.085H141.222C140.362 112.027 139.882 113.256 139.878 114.532C139.88 114.918 139.927 115.303 140.018 115.679L137.65 113.313L135.213 115.75L138.303 118.84L132.984 124.158L127.309 118.483L124.872 120.92L130.547 126.595L125.229 131.914L122.139 128.824L119.702 131.261L122.792 134.351L117.474 139.669L111.799 133.994L109.362 136.431L115.037 142.106L108.857 148.286ZM167.452 161.063H148.495V135.212H167.452V161.063ZM160.559 126.595H164.006C164.92 126.595 165.797 126.958 166.443 127.605C167.089 128.251 167.452 129.128 167.452 130.042V131.766H146.772C146.315 131.766 145.876 131.947 145.553 132.27C145.23 132.594 145.048 133.032 145.048 133.489V162.787C145.048 163.244 145.23 163.682 145.553 164.005C145.876 164.329 146.315 164.51 146.772 164.51H167.452V167.957C167.452 168.871 167.089 169.748 166.443 170.394C165.797 171.041 164.92 171.404 164.006 171.404H143.325C142.411 171.404 141.534 171.041 140.888 170.394C140.241 169.748 139.878 168.871 139.878 167.957V130.042C139.878 129.128 140.241 128.251 140.888 127.605C141.534 126.958 142.411 126.595 143.325 126.595H146.772C147.229 126.595 147.667 126.414 147.99 126.091C148.313 125.767 148.495 125.329 148.495 124.872V119.702H158.835V124.872C158.835 125.329 159.017 125.767 159.34 126.091C159.663 126.414 160.102 126.595 160.559 126.595ZM164.006 114.532C164.006 114.989 163.824 115.427 163.501 115.75C163.178 116.073 162.739 116.255 162.282 116.255H145.048C144.591 116.255 144.153 116.073 143.83 115.75C143.506 115.427 143.325 114.989 143.325 114.532C143.325 114.074 143.506 113.636 143.83 113.313C144.153 112.99 144.591 112.808 145.048 112.808H162.282C162.739 112.808 163.178 112.99 163.501 113.313C163.824 113.636 164.006 114.074 164.006 114.532ZM148.495 109.361V107.638C148.495 107.181 148.677 106.742 149 106.419C149.323 106.096 149.761 105.915 150.218 105.915H157.112C157.569 105.915 158.007 106.096 158.331 106.419C158.654 106.742 158.835 107.181 158.835 107.638V109.361H148.495ZM154.675 102.468H150.218C148.847 102.468 147.532 103.012 146.563 103.982C145.593 104.952 145.048 106.267 145.048 107.638H119.911L141.601 85.9472L156.399 100.744L154.675 102.468ZM153.665 93.1372L149.209 88.6805L154.527 83.3621L158.984 87.8188L153.665 93.1372ZM167.452 91.4138L150.932 74.8932L153.665 72.1599L170.186 88.6805L167.452 91.4138Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="secret-slide__text">
                По данным Федерального регистра СД в РФ на 01.01.2023 г. 4 581
                990 пациентов с СД 2 типа
                <sup>2</sup>
              </div>
            </div>
            <div class="secret__slider-slide">
              <div class="secret-slide__icon">
                <svg
                  width="243"
                  height="243"
                  viewBox="0 0 243 243"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.88675 126.5C1.10042 123.406 1.10042 119.594 2.88675 116.5L57.8632 21.2779C59.6496 18.1839 62.9508 16.2779 66.5235 16.2779L176.476 16.2779C180.049 16.2779 183.35 18.1839 185.137 21.2779L240.113 116.5C241.9 119.594 241.9 123.406 240.113 126.5L185.137 221.722C183.35 224.816 180.049 226.722 176.477 226.722L66.5235 226.722C62.9508 226.722 59.6496 224.816 57.8632 221.722L2.88675 126.5Z"
                    fill="#1070FF"
                  />
                  <path
                    d="M167.843 144.322C168.971 142.293 170.387 137.802 167.483 130.3C167.333 120.638 162.166 118.351 159.669 111.69C160.8 109.654 161.688 106.974 161.688 103.562C161.688 95.7214 158.144 93.7394 157.148 88.2853C161.246 83.1548 162.866 76.1159 160.783 68.1934C160.132 65.7173 156.383 66.6977 157.036 69.1796C160.322 81.6823 151.936 90 147.83 90C131.631 90 133.107 86.1347 120.994 86.0979C108.807 86.1347 110.491 90 94.1676 90C89.8411 90 81.7249 81.5021 84.9625 69.1796C85.6154 66.6977 81.8722 65.7231 81.2154 68.1934C79.1345 76.1081 80.7484 83.1509 84.8501 88.2853C83.9066 93.4584 80.3125 96.0314 80.3125 103.562C80.3125 106.976 81.2018 109.656 82.3314 111.692C79.8921 118.191 74.6666 120.767 74.5174 130.3C71.6131 137.804 73.0294 142.295 74.1571 144.322C72.0859 148.621 70.625 158.853 70.625 161.688C70.625 173.328 71.5705 174.231 72.0781 174.715C73.6862 176.242 76.1779 174.301 75.1103 172.375C75.0037 172.01 74.5 169.866 74.5 161.688C74.5 158.44 76.1159 149.359 77.4508 146.313C82.2171 146.906 87.427 148.206 92.6079 150.093C93.4875 150.605 94.2257 150.987 94.7411 151.188C96.8665 152.019 98.9512 154.633 105.63 156.297C111.704 159.928 116.323 163.995 119.059 168.103V173.312C119.059 175.876 122.934 175.878 122.934 173.312V168.104C125.669 163.997 130.288 159.93 136.362 156.299C146.707 153.719 145.986 148.623 164.543 146.313C165.884 149.359 167.5 158.44 167.5 161.688C167.5 169.866 166.996 172.01 166.89 172.375C165.799 174.345 168.351 176.209 169.922 174.715C170.429 174.231 171.375 173.328 171.375 161.688C171.375 158.853 169.914 148.621 167.843 144.322ZM77.5206 142.444C77.0556 141.638 76.3154 139.743 76.8153 136.421C78.4932 138.811 80.8957 141.245 83.4454 143.442C81.4871 143.018 79.51 142.685 77.5206 142.444ZM121 164.156C119.231 161.903 116.97 159.696 114.312 157.58C118.475 157.882 123.269 157.902 127.688 157.58C125.03 159.696 122.769 161.903 121 164.156ZM121 153.938C106.269 153.938 101.842 151.041 98.9125 149.125C98.0038 148.53 97.1474 147.97 96.1554 147.583C92.4994 146.151 78.375 135.448 78.375 130.688C78.375 123.158 82.0621 121.108 85.0187 115.211C87.1054 117.241 89.8528 118.396 91.5849 118.568C94.1501 118.824 94.5086 114.965 91.9704 114.713C91.1257 114.629 89.7481 113.946 89.0506 113.521C88.8511 113.401 84.1875 110.508 84.1875 103.562C84.1875 98.0794 86.5338 95.8706 88.0373 91.4299C90.0756 92.9741 92.2572 93.875 94.1676 93.875C110.677 93.875 110.065 90.0058 120.994 89.9729C132.09 90.0058 131.094 93.875 147.83 93.875C149.743 93.875 151.926 92.9741 153.963 91.4299C155.472 95.8919 157.812 98.06 157.812 103.562C157.812 111.165 153.161 114.796 145.752 115.854C143.213 116.214 143.76 120.053 146.3 119.688C149.541 119.225 154.24 117.873 156.979 115.207C159.942 121.116 163.625 123.154 163.625 130.688C163.625 135.448 149.501 146.151 145.845 147.581C141.689 149.208 139.991 153.938 121 153.938ZM165.187 136.419C165.688 139.738 164.948 141.634 164.481 142.444C162.563 142.669 160.579 143.01 158.555 143.444C161.106 141.245 163.507 138.811 165.187 136.419Z"
                    fill="white"
                  />
                  <path
                    d="M121 133.109C122.07 133.109 122.938 132.025 122.938 130.688C122.938 129.35 122.07 128.266 121 128.266C119.93 128.266 119.062 129.35 119.062 130.688C119.062 132.025 119.93 133.109 121 133.109Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="secret-slide__text">
                Согласно прогнозам Международной диабетической федерации к 2030
                году СД будет страдать 643 млн человек, а к 2045 году - 783 млн
                человек1,3
                <sup>1,3</sup>
              </div>
            </div>
            <template #customPaging="">
              <div class="secret__slider-dot"></div>
            </template>
          </VueSlickCarousel>
        </div>
      </div>
    </div>
    <div class="secret-video-block" v-if="videos && videos.length">
      <div class="content">
        <div class="secret-video-block__title">
          Сердечно-сосудистый континуум
        </div>
        <div class="secret-video-block__description">
          (Выберите интересующий Вас блок)
        </div>
        <div class="secret-video-block__tabs-wrap">
          <div class="secret-video-block__tabs">
            <div
              class="secret-video-block__tab"
              :class="{ 'secret-video-block__tab_active': tInd === activeTab }"
              v-for="(tab, tInd) in videos"
              :key="tInd"
              v-html="tab.title"
              @click="changeTab(tInd)"
            ></div>
          </div>
        </div>

        <div class="secret-video-block__body">
          <div
            class="secret-video-block__body-title"
            v-html="videos[activeTab].title"
          ></div>
          <div class="secret-video-block__row">
            <div class="secret-video-block__main" :class="{ paused }">
              <div
                class="secret-video-block__main-title"
                v-html="videos[activeTab].videos[activeVideo].title"
              ></div>
              <img
                class="secret-video-block__main-poster"
                :src="videos[activeTab].videos[activeVideo].poster"
              />
              <video
                controls
                ref="mainVideo"
                :src="videos[activeTab].videos[activeVideo].file"
              ></video>
              <div class="secret-video-block__main-tools">
                <div
                  class="
                    secret-video-block__main-arrow
                    secret-video-block__main-arrow_left
                  "
                  :style="`opacity: ${activeVideo > 0 ? 1 : 0}`"
                  @click="prevVideo()"
                >
                  <svg
                    width="24"
                    height="26"
                    viewBox="0 0 24 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.055 0.592529V13.1743V25.7313L7.8215 13.1743L23.055 0.592529Z"
                      fill="white"
                    />
                    <path
                      d="M4.21226 0.592529H0.329224V25.7064H4.21226V0.592529Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div class="secret-video-block__main-play" @click="playVideo()">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.443069 0.807602V16.1743V31.541L31.2087 16.1743L0.443069 0.807602Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  class="
                    secret-video-block__main-arrow
                    secret-video-block__main-arrow_right
                  "
                  :style="`opacity: ${
                    activeVideo < videos[activeTab].videos.length - 1 ? 1 : 0
                  }`"
                  @click="nextVideo()"
                >
                  <svg
                    width="24"
                    height="26"
                    viewBox="0 0 24 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.360718 0.592529V13.1743V25.7313L15.6191 13.1743L0.360718 0.592529Z"
                      fill="white"
                    />
                    <path
                      d="M23.111 0.592529H19.228V25.7064H23.111V0.592529Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="secret-video-block__list">
              <div
                class="secret-video-block__list-item"
                v-for="(video, vInd) in videos[activeTab].videos"
                v-show="vInd !== activeVideo"
                :key="vInd"
                @click="nextVideo(vInd)"
              >
                <img
                  :src="video.poster"
                  class="secret-video-block__list-item-img"
                />
                <div
                  class="secret-video-block__list-item-title"
                  v-html="video.title"
                ></div>
                <div class="secret-video-block__list-item-play">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.504089 0.584808V8.935V17.2852L17.0918 8.935L0.504089 0.584808Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-page__calendar">
      <div class="content">
        <div class="main-page__title">Календарь мероприятий</div>
        <div class="events-container">
          <EventsCalendar
            @dayClick="toEvents()"
            @goPrev="goPrev"
            @goNext="goNext"
            :notSetQuery="true"
            @updFilter="updFilter"
            :specialtiesList="['cardiology', 'nephrology', 'endocrinology']"
          />
          <div class="events-container__list">
            <div
              class="events-list"
              v-if="notPassedEvents && notPassedEvents.length"
            >
              <Event
                v-for="ind in 3"
                :key="ind"
                :event="notPassedEvents[ind - 1]"
                class="mb-4"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="materials main-page__section">
      <div class="content">
        <div class="main-page__title">Информационные материалы</div>
        <div class="main-page__materials-row">
          <div
            @click="toInfo({ name: 'Library' }, 'Библиотека')"
            class="main-page__material material main-page__library"
          >
            <picture>
              <source
                media="(max-width: 767px)"
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/library-mobile.jpg`"
              />
              <source
                media="(max-width: 1220px)"
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/library-tablet.jpg`"
              />
              <source
                media="(max-width: 99999999px)"
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/library.jpg`"
              />
              <img
                class="material__image"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/library.jpg`"
              />
            </picture>

            <div class="material__title">Библиотека</div>
            <div class="material__link">
              Подробнее
              <span class="ml-2">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 8L9 16L6.5 16L12.5 9L-3.0598e-07 9L-3.93402e-07 7L12.5 7L6.5 -2.84124e-07L9 -3.93402e-07L16 8Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div
            @click="toInfo({ name: 'Podcasts' }, 'Подкасты')"
            class="main-page__material material main-page__podcasts"
          >
            <img
              class="material__image"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/podcasts.jpg`"
            />
            <div class="material__title">Подкасты</div>
            <div class="material__podcast-title">
              300+ <span>аудио и видеоподкастов <br />для врачей</span>
            </div>
            <div class="material__link">
              Подробнее
              <span class="ml-2">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 8L9 16L6.5 16L12.5 9L-3.0598e-07 9L-3.93402e-07 7L12.5 7L6.5 -2.84124e-07L9 -3.93402e-07L16 8Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div
            @click="toInfo({ name: 'VideoMaterials' }, 'Видеоматериалы')"
            class="
              main-page__material
              material
              main-page__video
              material_horizontal
            "
          >
            <div class="material__title">Видеоматериалы</div>
            <div class="material__text-wrap">
              <div class="material__description">
                Коллекция вебинаров, конференций, интервью и семинаров. Ведущие
                специалисты со всего мира.
              </div>
              <div class="material__link">
                Подробнее
                <span class="ml-2">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16 8L9 16L6.5 16L12.5 9L-3.0598e-07 9L-3.93402e-07 7L12.5 7L6.5 -2.84124e-07L9 -3.93402e-07L16 8Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="content">
      <div class="sources">
        <div class="source">
          <input type="checkbox" id="source1" />
          <label for="source1" class="source__head">
            <div class="source__title">Источники</div>
            <div class="source__arrow">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.0306 9.53068L12.5306 17.0307C12.461 17.1004 12.3782 17.1557 12.2872 17.1935C12.1961 17.2312 12.0986 17.2506 12 17.2506C11.9014 17.2506 11.8038 17.2312 11.7128 17.1935C11.6217 17.1557 11.539 17.1004 11.4694 17.0307L3.96936 9.53068C3.82863 9.38995 3.74957 9.19907 3.74957 9.00005C3.74957 8.80103 3.82863 8.61016 3.96936 8.46943C4.1101 8.32869 4.30097 8.24963 4.49999 8.24963C4.69901 8.24963 4.88988 8.32869 5.03061 8.46943L12 15.4397L18.9694 8.46943C19.039 8.39974 19.1218 8.34447 19.2128 8.30676C19.3039 8.26904 19.4014 8.24963 19.5 8.24963C19.5985 8.24963 19.6961 8.26904 19.7872 8.30676C19.8782 8.34447 19.9609 8.39974 20.0306 8.46943C20.1003 8.53911 20.1556 8.62183 20.1933 8.71288C20.231 8.80392 20.2504 8.9015 20.2504 9.00005C20.2504 9.0986 20.231 9.19618 20.1933 9.28722C20.1556 9.37827 20.1003 9.46099 20.0306 9.53068Z"
                  fill="#1A212B"
                />
              </svg>
            </div>
          </label>
          <div class="source__body">
            <ol>
              <li>
                Алгоритмы специализированной медицинской помощи больным сахарным
                диабетом / Под редакцией И.И. Дедова, М.В. Шестаковой, А.Ю.
                Майорова. – 11-й выпуск. – М; 2023.
              </li>
              <li>
                И.И. Дедов, М.В. Шестакова, О.К. Викулова. САХАРНЫЙ ДИАБЕТ В
                РОССИЙСКОЙ ФЕДЕРАЦИИ: ДИНАМИКА ЭПИДЕМИОЛОГИЧЕСКИХ ПОКАЗАТЕЛЕЙ ПО
                ДАННЫМ ФЕДЕРАЛЬНОГО РЕГИСТРА САХАРНОГО ДИАБЕТА ЗА ПЕРИОД
                2010–2022 ГГ.Сахарный диабет. 2023;26(2):104-123
              </li>
              <li>
                <a href="https://www.diabetesatlas.org/en/" target="_blank"
                  >https://www.diabetesatlas.org/en/</a
                >
                дата обращения 08.05.2024
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import EventsCalendar from "@/components/main/events/calendar/EventsCalendar.vue";
import Event from "@/components/main/events/Event.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "NePoSekrety",
  components: {
    VueSlickCarousel,
    EventsCalendar,
    Event,
  },
  data: () => ({
    settings: {
      arrows: false,
      dots: true,
      draggable: false,
      dotsClass: "secret__slider-dots",
    },
    activeTab: 0,
    activeVideo: 0,
    paused: true,
  }),
  computed: {
    ...mapGetters(["FilteredEvents", "Tabs"]),
    notPassedEvents() {
      return this.FilteredEvents.filter(
        (el) =>
          !el.state &&
          el.nosology.filter((nos) =>
            ["cardiology", "nephrology", "endocrinology"].includes(nos.slug)
          ).length
      );
    },
    videos() {
      return this.Tabs.filter((tab) => tab.videos.length);
    },
  },
  methods: {
    ...mapActions(["fetchEvents", "fetchTabs"]),
    prevVideo() {
      if (this.activeVideo > 0) {
        this.$set(this, "activeVideo", this.activeVideo - 1);
      }
    },
    nextVideo(ind) {
      if (typeof ind !== "undefined") {
        this.$set(this, "activeVideo", ind);
         this.$set(this, "paused", true);
        return;
      }
      if (this.activeVideo < this.videos[this.activeTab].videos.length - 1) {
        this.$set(this, "activeVideo", this.activeVideo + 1);
      }
    },
    playVideo() {
      this.$refs.mainVideo.play();
      this.$set(this, "paused", false);
    },
    changeTab(tab) {
      this.$set(this, "activeTab", tab);
    },

    async updFilter(filter) {
      await this.fetchEvents(filter);
    },
    toEvents() {
      if (window.innerWidth < 768) {
        this.$refs.eventsList.scrollIntoView({ behavior: "smooth" });
      }
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "main calendar date click", {
          "main calendar date click": {
            ...this.$root.ymFields,
          },
        });
      }
    },
    goPrev(month) {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "main calendar month fllter use", {
          "main calendar month fllter use": {
            month: month,
            ...this.$root.ymFields,
          },
        });
      }
    },
    goNext(month) {
      if (typeof ym !== "undefined") {
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "main calendar month fllter use", {
            "main calendar month fllter use": {
              month: month,
              ...this.$root.ymFields,
            },
          });
        }
      }
    },
    toInfo(to, text) {
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "main info materials click", {
          "main info materials click": {
            "material name": text,
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(to).catch(() => {});
    },
  },
  async created() {
    await this.fetchTabs().then(() => {
      this.$refs.mainVideo.addEventListener("pause", () => {
        this.$set(this, "paused", true);
      });
    });
  },
  mounted() {
    
  },
};
</script>

<style lang="scss" scoped>
.secret {
  &__top {
    min-height: 544px;
    padding: 18px 0;
    position: relative;

    @media screen and (max-width: 1220px) {
      padding: 18px 0 48px;
    }

    &-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    &-text {
      position: relative;
      max-width: 50%;
      padding: 10px 0 30px;
      border-left: 1px solid #d4d4d4;

      @media screen and (max-width: 1220px) {
        max-width: none;
      }

      &::before,
      &::after {
        position: absolute;
        left: 0;
        width: 61px;
        height: 61px;
        border-top: 1px solid #1070ff;
        border-left: 1px solid #1070ff;
        display: block;
        content: "";
        z-index: 2;
      }

      &::before {
        top: 0;
      }

      &::after {
        bottom: 0;
        transform: rotate(-90deg);
      }
    }

    &-caption {
      padding-left: 45px;
      margin-bottom: 10px;
      font-family: "Roboto Slab", sans-serif;
      font-size: 50px;
      font-weight: 400;
      line-height: 65px;
      text-align: left;
      color: #1070ff;

      @media screen and (max-width: 767px) {
        font-size: 30px;
        line-height: 39px;
      }
    }

    &-subcaption {
      padding-left: 45px;
      margin-bottom: 20px;
      font-family: "Roboto", sans-serif;
      font-size: 20px;
      font-weight: 300;
      line-height: 23px;
      text-align: left;
      color: #444444;
      padding-bottom: 16px;
      border-bottom: 1px solid #d4d4d4;

      @media screen and (max-width: 767px) {
        font-size: 16px;
        line-height: 18px;
      }
    }

    &-description {
      font-family: "Roboto", sans-serif;
      font-size: 18px;
      font-weight: 300;
      line-height: 24px;
      text-align: left;
      color: #444444;
      padding-left: 45px;

      @media screen and (max-width: 767px) {
        font-size: 14px;
        line-height: 16px;
      }
    }

    &-button {
      margin-top: 20px;
      margin-left: 45px;
      color: #fff;
      background-color: #5dacf8;
      width: fit-content;
      padding: 16px 24px;
      font-size: 24px;
      font-weight: 400;

      &:hover {
        background-color: #1070ff;
      }
    }
  }

  &__slider {
    padding: 45px 0;

    &-container {
      position: relative;
    }
    &-arrows {
      position: absolute;
      top: 20px;
      right: 80px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: fit-content;
      z-index: 2;

      @media screen and (max-width: 1220px) {
        position: static;
        justify-content: center;
        width: 100%;
        margin-bottom: 32px;
      }
    }

    &-arrow {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      border: 1px solid #1070ff;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: 0.3s;
      color: #1070ff;
      &:hover {
        background-color: #1070ff;
        color: #fff;
      }

      &_left {
        margin-right: 16px;
      }
    }

    &-dot {
      width: 18px;
      height: 18px;
      border: 1px solid #ababab;
      border-radius: 50%;
      display: flex !important;
      justify-content: center;
      align-items: center;
    }
    &-slider {
      box-shadow: 0px 4px 40px 0px #1070ff33;
      padding: 45px 90px;
      border-radius: 70px;
      @media screen and (max-width: 1220px) {
        padding: 16px 16px 32px;
        border-radius: 14px;
      }
    }

    &-slide {
      display: flex !important;
      justify-content: flex-start;
      align-items: center;

      @media screen and (max-width: 1220px) {
        height: 347px;
        position: relative;

        &::before,
        &:after {
          position: absolute;
          width: 43px;
          height: 36px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          display: block;
          content: "";
        }
        &::before {
          top: 10px;
          left: 0;
          background-image: url("data:image/svg+xml,%3Csvg width='43' height='36' viewBox='0 0 43 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.5398 20.3239L17.5398 35.9979L5.50883e-07 35.9979L3.61517e-07 23.6236C2.58993e-07 16.9241 0.968403 12.0758 2.90938 9.0746C5.45353 5.07576 9.48158 2.05159 14.9956 0L18.9945 5.24899C15.6614 6.39896 13.207 8.11245 11.6334 10.3853C10.0576 12.6602 9.17895 15.9724 8.99738 20.3218L17.5398 20.3218L17.5398 20.3239Z' fill='%231070FF'/%3E%3Cpath d='M41.5456 20.3239L41.5456 35.9979L24.0059 35.9979L24.0059 23.6236C24.0059 16.9241 24.9743 12.0758 26.9132 9.0746C29.4573 5.07576 33.4874 2.05159 39.0015 0L43.0003 5.24899C39.6673 6.39896 37.215 8.11245 35.6392 10.3853C34.0635 12.6602 33.1848 15.9724 33.0032 20.3218L41.5456 20.3218L41.5456 20.3239Z' fill='%231070FF'/%3E%3C/svg%3E%0A");
        }
        &::after {
          bottom: 0;
          right: 3px;
          background-image: url("data:image/svg+xml,%3Csvg width='43' height='36' viewBox='0 0 43 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.4602 15.6739L25.4602 -5.88939e-05L43 -5.72205e-05L43 12.3742C43 19.0737 42.0316 23.922 40.0906 26.9232C37.5465 30.922 33.5184 33.9462 28.0044 35.9978L24.0055 30.7488C27.3386 29.5988 29.793 27.8854 31.3666 25.6125C32.9424 23.3376 33.8211 20.0254 34.0026 15.676L25.4602 15.676L25.4602 15.6739Z' fill='%231070FF'/%3E%3Cpath d='M1.45462 15.6739L1.45462 -5.88939e-05L18.9944 -5.72205e-05L18.9944 12.3742C18.9944 19.0737 18.026 23.922 16.0871 26.9232C13.5429 30.922 9.51281 33.9462 3.99876 35.9978L-7.01514e-05 30.7488C3.33299 29.5988 5.78529 27.8854 7.36103 25.6125C8.93678 23.3376 9.81543 20.0254 9.99701 15.676L1.45462 15.676L1.45462 15.6739Z' fill='%231070FF'/%3E%3C/svg%3E%0A");
        }
      }
    }
  }

  &-slide {
    &__text {
      font-family: "Roboto", sans-serif;
      font-size: 30px;
      font-style: italic;
      font-weight: 300;
      line-height: 35px;
      text-align: left;
      margin-left: 100px;

      @media screen and (max-width: 1220px) {
        margin-left: 0;
        text-align: center;
        font-size: 20px;
        line-height: 24px;

        &::before {
          position: absolute;
          bottom: 33px;
          left: 50%;
          transform: translateX(-50%);
          width: 30%;
          height: 2px;
          background-color: #1070ff;
          content: "";
          display: block;
        }
      }
    }

    &__icon {
      @media screen and (max-width: 1220px) {
        display: none;
      }
    }
  }
}

.secret-video-block {
  padding: 85px 0 100px;
  background-image: url("https://storage.yandexcloud.net/"+$VUE_APP_BACKET_NAME+"/media/content/public/assets/img/secret/video-back.svg");
  background-size: cover;
  background-position: top center;
  @media screen and (max-width: 1220px) {
    padding: 48px 0;
  }

  & > .content {
    @media screen and (max-width: 1220px) {
      padding: 0;
    }
  }

  &__title {
    font-family: "Roboto", sans-serif;
    font-size: 50px;
    font-weight: 700;
    line-height: 58px;
    text-align: center;
    margin-bottom: 16px;
    color: #444444;

    @media screen and (max-width: 1220px) {
      font-size: 25px;
      line-height: 29px;
    }
  }

  &__description {
    font-family: "Roboto", sans-serif;
    font-size: 30px;
    font-style: italic;
    font-weight: 300;
    line-height: 35px;
    text-align: center;
    color: #444444;

    @media screen and (max-width: 1220px) {
      font-size: 16px;
      line-height: 18px;
    }
  }

  &__tabs {
    padding: 0 68px;
    margin-top: 70px;
    display: grid;
    grid-template-columns: repeat(5, 0.2fr);
    column-gap: 4px;
    @media screen and (max-width: 767px) {
      padding: 0 16px;
      grid-template-columns: repeat(5, 135px);
    }

    &-wrap {
      @media screen and (max-width: 1220px) {
        width: 100%;
        overflow-x: auto;
      }
    }
  }

  &__tab {
    background-color: #fff;
    height: 72px;
    border: 1px solid #d1e9fd;
    border-radius: 30px 30px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Roboto", sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 23px;
    text-align: center;
    color: #444444;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      color: #fff;
      background-color: #0e64e5;
      border-color: #0e64e5;
    }

    &_active {
      color: #fff;
      background-color: #1070ff;
      border-color: #1070ff;
    }

    @media screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 18px;
    }
  }

  &__body {
    box-shadow: 0px 4px 40px 0px #1070ff33;
    border-radius: 70px;
    padding: 50px;
    background-color: #fff;

    @media screen and (max-width: 1220px) {
      border-radius: 15px;
      padding: 24px 16px;
    }

    &-title {
      font-family: "Roboto", sans-serif;
      font-size: 40px;
      font-weight: 400;
      line-height: 46px;
      color: #3c4242;
      margin-bottom: 32px;

      @media screen and (max-width: 767px) {
        font-size: 25px;
        line-height: 30px;
      }
    }
  }

  &__main {
    width: 100%;
    height: 500px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;

    @media screen and (max-width: 767px) {
      height: 164px;
    }

    & > video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    &:not(.paused) {
      & .secret-video-block__main {
        &-poster {
          display: none;
        }
        &-tools {
          display: none;
        }
        &-title {
          display: none;
        }
      }
    }

    &-poster {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      z-index: 2;
    }

    &-title {
      position: absolute;
      max-width: 40%;
      top: 20px;
      left: 20px;
      z-index: 3;
      font-family: "Roboto Slab", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 21px;
      text-align: left;
      color: #fff;

      @media screen and (max-width: 767px) {
        font-size: 12px;
        line-height: 16px;
        max-width: 80%;
      }
    }

    &-tools {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 4;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-play {
      margin: 0 30px;
      padding-left: 10px;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(53, 53, 53, 0.5);
      cursor: pointer;
      transition: 0.3s;
      flex-shrink: 0;
      &:hover {
        opacity: 0.8;
      }

      @media screen and (max-width: 767px) {
        width: 32px;
        height: 32px;
        padding-left: 3px;

        & > svg {
          width: 16px;
          height: 16px;
        }
      }
    }

    &-arrow {
      cursor: pointer;
      transition: 0.3s;
      @media screen and (max-width: 767px) {
        width: 10px;

        & > svg {
          width: 100%;
        }
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }

  &__row {
    display: grid;
    grid-template-columns: 0.75fr 0.25fr;
    column-gap: 10px;

    @media screen and (max-width: 767px) {
      grid-template-columns: 1fr;
      row-gap: 24px;
    }
  }

  &__list {
    max-height: 500px;
    overflow-y: auto;
    padding-right: 10px;

    @media screen and (max-width: 767px) {
      display: flex;
      gap: 10px;
      overflow-x: auto;
    }

    &::-webkit-scrollbar {
      height: 8px;
      border-radius: 5px;
      width: 7px;
    }

    &::-webkit-scrollbar-thumb {
      background: #9acff9;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #eff6ff;
      border-radius: 8px;
    }

    &-item {
      position: relative;
      width: 100%;
      height: 165px;
      border-radius: 8px;
      overflow: hidden;
      margin-bottom: 10px;

      @media screen and (max-width: 1220px) {
        height: 120px;
        flex-shrink: 0;
      }

      @media screen and (max-width: 767px) {
        width: 200px;
        height: 120px;
        flex-shrink: 0;
      }

      &-img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: center;
      }

      &-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 4;
        padding-left: 5px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(53, 53, 53, 0.5);
        cursor: pointer;
        transition: 0.3s;
        &:hover {
          opacity: 0.8;
        }

        @media screen and (max-width: 767px) {
          width: 32px;
          height: 32px;
          padding-left: 3px;

          & > svg {
            width: 16px;
            height: 16px;
          }
        }
      }

      &-title {
        position: absolute;
        bottom: 10px;
        left: 10px;
        z-index: 4;
        font-family: "Roboto Slab", sans-serif;
        font-size: 12px;
        font-weight: 400;
        line-height: 15px;
        text-align: left;
        color: #fff;
      }
    }
  }
}

sub,
sup {
  vertical-align: super;
  font-family: inherit;
  font-style: inherit;
  font-weight: inherit;
  font-size: smaller;
  line-height: 22px;
  color: inherit;
  white-space: nowrap;
}

.main-page {
  &__title {
    margin-bottom: 40px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 56px;
    color: #1f1f1f;

    @media screen and (max-width: 1220px) {
      margin-bottom: 32px;
    }

    @media screen and (max-width: 767px) {
      font-size: 23px;
      line-height: 28px;
    }
  }

  &__materials-row {
    @media screen and (max-width: 1220px) {
      display: block;
    }
  }
}

.main-page__section {
  display: none;
  @media screen and (max-width: 1220px) {
    display: block;
  }
}

.material {
  position: relative;
  height: 625px;
  padding: 64px;
  display: flex;
  flex-direction: column;
  color: #1f1f1f;
  cursor: pointer;

  &:hover .material__link {
    color: #da338c;
  }

  @media screen and (max-width: 1220px) {
    height: 320px;
    padding: 24px;
    margin-bottom: 16px;
  }

  @media screen and (max-width: 767px) {
    height: 205px;
  }

  &_horizontal {
    flex-direction: row;

    @media screen and (max-width: 1220px) {
      flex-direction: column;
    }
  }

  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  &__text-wrap {
    max-width: 45%;
    margin-left: auto;
    margin-right: auto;
    border-left: 1px solid #b3bb61;
    padding-left: 62px;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 1220px) {
      margin: auto 0;
      max-width: none;
      border: 0;
      padding: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }

  &__description {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    color: #1f1f1f;

    @media screen and (max-width: 1220px) {
      margin: auto 0 0;
    }

    @media screen and (max-width: 767px) {
      margin-top: 16px;
      font-size: 14px;
      line-height: 20px;
    }
  }

  &.main-page__video {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 2;
    grid-row-end: 3;
    background-color: #c4d600;
    padding-right: 0;
    height: 288px;
    @media screen and (max-width: 1220px) {
      height: 320px;
      padding-right: 24px;
    }

    @media screen and (max-width: 767px) {
      height: 205px;
    }
  }

  &__podcast-title {
    margin: auto 0;
    position: relative;
    z-index: 2;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 450;
    font-size: 211px;
    line-height: 228px;
    color: #830051;

    @media screen and (max-width: 1220px) {
      font-size: 131px;
      line-height: 142px;
      width: fit-content;
    }

    @media screen and (max-width: 767px) {
      font-size: 64px;
      line-height: 78px;
    }

    & span {
      position: absolute;
      bottom: 0;
      right: 0;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #3c4242;

      @media screen and (max-width: 1220px) {
        bottom: auto;
        top: 90%;
      }

      @media screen and (max-width: 1220px) {
        left: 95%;
        right: auto;
        top: 60%;
      }
    }
  }

  &__title {
    position: relative;
    z-index: 2;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 35px;
    color: inherit;

    @media screen and (max-width: 767px) {
      font-size: 21px;
      line-height: 27px;
    }
  }

  &__link {
    margin-top: auto;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    transition: 0.3s;
  }
}

.main-page__calendar {
  padding: 85px 0;
  @media screen and (max-width: 767px) {
    padding: 48px 0;
  }
}

.events-list {
  &__title {
    margin-top: 32px;
    margin-bottom: 16px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #830051;
  }

  &__button {
    margin: 32px auto 0;
    width: 173px;

    @media screen and (max-width: 1220px) {
      margin: 32px 0 0;
    }
  }
}

.events-container {
  display: grid;
  grid-template-columns: 0.4fr 0.6fr;
  column-gap: 32px;

  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
    row-gap: 32px;
  }
}

.calendar {
  max-width: 100%;
  width: 100%;
}

.sources {
  padding: 24px 0;
  border-top: 1px solid #adadad;
  border-bottom: 1px solid #adadad;
}

.source {
  &__head {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__title {
    font-family: "Roboto", sans-serif;
    font-size: 40px;
    font-weight: 400;
    line-height: 46px;
    text-align: left;
    margin-right: 30px;
    color: #3c4242;
    @media screen and (max-width: 767px) {
      font-size: 25px;
      line-height: 30px;
    }
  }

  &__arrow {
    margin-left: auto;
    transition: 0.3s;
    cursor: pointer;
  }

  & > input {
    display: none;

    &:checked {
      & ~ .source__head {
        & .source {
          &__arrow {
            transform: rotate(180deg);
          }
        }
      }
      & ~ .source__body {
        margin-top: 20px;
        max-height: 100000px;
      }
    }
  }

  &__body {
    max-height: 0;
    overflow: hidden;
    transition: 0.3s;
  }
}

ol {
  list-style: decimal;
  padding-left: 15px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #3c4242;
}
</style>


<style lang="scss">
.secret__slider-dots {
  display: flex !important;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.slick-active .secret__slider-dot {
  border-color: #1070ff;
  &::before {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #1070ff;
    display: block;
    content: "";
  }
}

.secret-video-block__body-title > br {
  display: none;
}

.secret .selectaria__select {
  max-width: 100%;
}
</style>